export const PermissionBanners = {
    PUT: "mgr-banners-**-PUT",
    POST: "mgr-banners-POST",
    DELETE: "mgr-banners-**-DELETE",
    GET: "mgr-banners-search-GET",
    GET_UUID: "mgr-banners-**-GET",
    DELETE_IMAGE: "mgr-banners-**-image-**-DELETE",
    POST_IMAGE: "mgr-files-POST",
};